import Cookies from 'js-cookie';
import { trackCompareGridEvents } from './trackCompareGridEvents';
import {
  COMPARE_TABLE_CLICK_COOKIE,
  CompareTableClickCookieData,
} from './setCompareTableClickCookie';

const handleCompareTableClickTracking = () => {
  const raw = Cookies.get(COMPARE_TABLE_CLICK_COOKIE);
  if (!raw) return;

  let data: CompareTableClickCookieData | undefined;
  try {
    data = JSON.parse(raw);
  } catch (e) {
    console.error(`Error parsing ${COMPARE_TABLE_CLICK_COOKIE} cookie`, e);
  } finally {
    Cookies.remove(COMPARE_TABLE_CLICK_COOKIE);
  }

  if (data) {
    trackCompareGridEvents(data);
  }
};

export default handleCompareTableClickTracking;
